import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { MatIcon } from "@angular/material/icon";
import { NgClass, UpperCasePipe } from "@angular/common";
import { SvgIconComponent } from "angular-svg-icon";
import { Subscription } from "rxjs";

export const AVAILABLE_LANGUAGES: string[] = ["en", "fr", "de", "it"];
export const DEFAULT_LANGUAGE: string = "en";

@Component({
  selector: "app-lang-manager",
  templateUrl: "./lang-manager.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./lang-manager.component.scss"],
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    NgClass,
    UpperCasePipe,
    SvgIconComponent
  ]
})
export class LangManagerComponent implements OnInit, OnDestroy {
  public activeLang: string;
  public langs: { code: string; name: string }[] = [
    {
      code: "en",
      name: "english"
    },
    {
      code: "fr",
      name: "français"
    },
    {
      code: "de",
      name: "deutsch"
    },
    {
      code: "it",
      name: "italiano"
    }
  ];

  private langChangeSub: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.langs = this.langs.filter((lang) =>
      AVAILABLE_LANGUAGES.includes(lang.code)
    );

    // `translate.use()` resolves asynchronously, so currentLang can still be
    // unset on first paint. Always fall back to a real code: the template
    // builds an icon name from it ("flag-" + activeLang).
    this.activeLang = this.resolveLang(this.translate.currentLang);

    this.langChangeSub = this.translate.onLangChange.subscribe((event) => {
      this.activeLang = this.resolveLang(event.lang);
    });
  }

  ngOnDestroy() {
    this.langChangeSub?.unsubscribe();
  }

  setLang(lang: string): void {
    if (
      !AVAILABLE_LANGUAGES.includes(lang) ||
      this.translate.currentLang === lang
    )
      return;

    this.translate.use(lang);
    this.activeLang = lang;
    localStorage.setItem("pref-lang", lang);
  }

  private resolveLang(lang: string): string {
    if (AVAILABLE_LANGUAGES.includes(lang)) return lang;

    const fallback = this.translate.getDefaultLang();
    return AVAILABLE_LANGUAGES.includes(fallback) ? fallback : DEFAULT_LANGUAGE;
  }
}
